
export class Condition {

  name:string = "headers.from";
  operator:string = "present";
  value:string = "";
    
}
